import NewQuiz from "components/Admin/Quiz/NewQuiz";
import AddSpeaker from "components/Admin/Speaker/AddSpeaker";
import DateTimeField from "components/InputField/DateTimeField";
import FileField from "components/InputField/FileField";
import InputField from "components/InputField/InputField";
import SelectField from "components/InputField/SelectField";
import constants from "constants";
import _ from "lodash";
import PropTypes, { func } from "prop-types";
import React from "react";
import { connect } from "react-redux";
// import DisciplineTagSelect from 'containers/Input/DisciplineTagSelect';
import { FormControl, FormControlLabel } from "material-ui/Form";
import Icon from "material-ui/Icon";
import Radio, { RadioGroup } from "material-ui/Radio";
import moment from "moment";
import Select from "react-select";
import pdfPlaceholder from "../../../assets/img/pdfPlaceholder.png";

const { CPD_STATUSES, REF_TYPES } = constants;

const labels = {
  faculty: "faculty",
  price: "Price &#8364;",
  webinar_title: "Webinar topic",
  number_cpd_points: "Number of CPD points",
  vimeo_url: "Vimeo video uid",
  join_url: "Join URL",
  status: "Status",
  cpd_points: "Type of CPD points",
  partnerships_ids: "Partner",
  int_cpd_points: "Number of Int CPD points",
  ext_cpd_points: "Number of Ext CPD points",
  icgp_ref: "Application Reference Number (ARN)",
  rcpi_ref: "RCPI Ref #",
  ipna_ref: "IGPNEA Ref #",
  ref_type: "Ref Type",
  discipline: "Discipline",
  gms_study_days: "GMS Study Leave",
  audio_link: "Audio link",
  sponsor: "Sponsor",
  sponsorship_value: "Enter Sponsorship value",
};

const statuses = [
  { value: "published", label: "Published" },
  { value: "unpublished", label: "Unpublished" },
];
const refType = [
  { value: REF_TYPES.ICGP, label: "ICGP" },
  { value: REF_TYPES.RCPI, label: "RCPI" },
  { value: REF_TYPES.FSEM, label: "FSEM" },
  { value: REF_TYPES.IPNA, label: "IGPNEA" },
  {
    value: REF_TYPES.CERTIFICATE_OF_PARTICIPATION,
    label: "Certificate of Participation",
  },
  {
    value: REF_TYPES.NMBI,
    label: "NMBI CPD Certificate",
  },
];

const cpdPoints = [
  { value: "external", label: "External" },
  { value: "internal", label: "Internal" },
  { value: "both", label: "Both" },
];

const cpdStatus = [
  { value: CPD_STATUSES.granted, label: "Granted" },
  { value: CPD_STATUSES.applied_for, label: "Applied for" },
  { value: CPD_STATUSES.not_applicable, label: "Not applicable" },
];

const onlyConsultantAndOrNCHD = [];

const hideMore = (roles, counties, onConsultantOrHD) => {
  let matches = _.intersection(roles, onlyConsultantAndOrNCHD);
  if (roles && roles.length && roles.length === matches.length) {
    const selectedCounties = counties.map((county) => county.value);
    onConsultantOrHD(selectedCounties);
    return true;
  } else {
    return false;
  }
};

const getCertificateRefFieldName = (certificateRef) => {
  if (certificateRef === REF_TYPES.ICGP) {
    return "icgp_ref";
  }
  if (certificateRef === REF_TYPES.RCPI) {
    return "rcpi_ref";
  }
  if (certificateRef === REF_TYPES.IPNA) {
    return "ipna_ref";
  }
};

const EditWebinarForm = ({
  webinar = {},
  errors = {},
  onFieldChange,
  onQuizAdd,
  onQuizChange,
  onQuizRemove,
  onSessionAdd,
  onSubmit,
  cpdPointsFields,
  onCpdPointsChange,
  onCpdTypeChange,
  counties,
  onConsultantOrHD,
  onExpertAdd,
  onExpertRemove,
  showUsersModal,
  onExpertChange,
  goToAddUsersPage,
  onCertificateRefChange,
  onWebinarFacultyTypeChange,
  onDragEnd,
  onSelectChangeDisciplineSearch,
  search_disciplines,
  handleSponsorshipChange,
  // handleSponsorRepresentativeChange,
  // sponsorsRepresentative,
  handleAudioLink,
  handleSponsorShipValueChange,
  onWebinarTypeChange,
  onDateChange,
  onSponsorChange,
  sponsorsOptions,
}) => {
  const hideMoreValue = hideMore(
    webinar.user_types,
    counties,
    onConsultantOrHD
  );

  const isCertificateOfParticipation =
    webinar.ref_type === REF_TYPES.CERTIFICATE_OF_PARTICIPATION;

  const isCustomCertificate = isCertificateOfParticipation;

  return (
    <div className="container_records">
      <div className="add_webinar">
        <h3>Webinar #{webinar.id}</h3>
        <div className="add_webinar_bg row">
          <form className="col s12">
            <br />
            <div className="block-radiogroup">
              {/* <FormControl className="wimin-webinar">
                Are you seeking sponsorship
                <RadioGroup
                  aria-label="Sponsorship"
                  label="Sponsorship"
                  value={webinar.is_sponsored}
                  onChange={(e) =>
                    handleSponsorshipChange(e.target.value === "true")
                  }
                  row
                >
                  <FormControlLabel
                    value={true}
                    control={<Radio color="primary" />}
                    label="Yes"
                  />
                  <FormControlLabel
                    value={false}
                    control={<Radio color="primary" />}
                    label="No"
                  />
                </RadioGroup>
              </FormControl> */}

              {/* {webinar.is_sponsored && (
                <div>
                  <SelectField
                    className="col s12"
                    label={labels["sponsor"]}
                    onChange={(e) =>
                      handleSponsorRepresentativeChange(e.target.value)
                    }
                    errors={errors["cpd_status"]}
                    field_name="cpd_status"
                    value={webinar.sponsor_representative_id}
                    options={sponsorsRepresentative.map(
                      ({ id, full_name }) => ({
                        value: id,
                        label: full_name,
                      })
                    )}
                  />
                  <InputField
                    className="coll s12"
                    label={labels["sponsorship_value"]}
                    field_name="sponsorship_value"
                    onChange={(e) =>
                      handleSponsorShipValueChange(e.target.value)
                    }
                    errors={errors["sponsorship_value"]}
                    value={webinar.sponsorship_value}
                  />
                </div>
              )} */}

              {webinar.qrcode_url && (
                <a
                  className="button_classic_session"
                  style={{ cursor: "pointer" }}
                  href={webinar.qrcode_url}
                  target="_blank"
                >
                  Export QR
                </a>
              )}
            </div>

            <div className="col s12">
              <a className="button_classic-new" onClick={goToAddUsersPage}>
                Add User
              </a>
            </div>
            <div className="col s12">
              <a className="button_classic-new" onClick={showUsersModal}>
                Assigned users
              </a>
            </div>

            {/* <FormControl>
              <RadioGroup
                aria-label="webinar type"
                value={webinar.webinar_type}
                onChange={onWebinarTypeChange}
                row
              >
                <FormControlLabel
                  value="online"
                  control={<Radio color="primary" />}
                  label="Webinar"
                />
                <FormControlLabel
                  value="audio"
                  control={<Radio color="primary" />}
                  label="Audio recorded"
                />
              </RadioGroup>
            </FormControl> */}

            {webinar.webinar_type === "online" && (
              <InputField
                className="col s12"
                label={labels["join_url"]}
                field_name={"join_url"}
                onChange={onFieldChange}
                errors={errors["join_url"]}
                autoComplete="new-password"
                value={webinar.join_url}
              />
            )}

            {webinar.webinar_type === "online" && (
              <DateTimeField
                className="col s12"
                onChange={onDateChange}
                value={webinar.start_date}
                label="Start date"
                field_name="start_date"
                errors={errors["start_date"]}
              />
            )}
            {webinar.webinar_type === "online" && (
              <DateTimeField
                className="col s12"
                onChange={onDateChange}
                value={webinar.end_date}
                label="End date"
                field_name="end_date"
                errors={errors["end_date"]}
              />
            )}

            {webinar.webinar_type === "audio" && (
              <InputField
                className="coll s12"
                label={labels["audio_link"]}
                field_name="audio_link"
                onChange={(e) => handleAudioLink(e.target.value)}
                errors={errors["audio_link"]}
                value={webinar["audio_link"] || ""}
              />
            )}

            <InputField
              className="coll s12"
              label={labels["webinar_title"]}
              field_name="webinar_title"
              onChange={onFieldChange}
              errors={errors["webinar_title"]}
              autoComplete="new-password"
              value={webinar["webinar_title"]}
            />

            {search_disciplines.length && (
              <div>
                <div className="col s12">
                  <Select
                    placeholder="Webinar discipline"
                    value={webinar.search_disciplines}
                    onChange={onSelectChangeDisciplineSearch}
                    multi={true}
                    options={search_disciplines.map((discipline) => ({
                      value: discipline.id,
                      label: discipline.title,
                    }))}
                  />
                  <div style={{ color: "red", fontSize: "0.875rem" }}>
                    {(errors.search_disciplines || []).join(". ")}
                  </div>
                </div>
                <div>
                  <a
                    className="false"
                    style={
                      webinar.search_disciplines.length ===
                      search_disciplines.length
                        ? { display: "none", cursor: "pointer" }
                        : { cursor: "pointer" }
                    }
                    onClick={() => {
                      onSelectChangeDisciplineSearch(search_disciplines);
                    }}
                  >
                    Select all
                  </a>
                  &nbsp;
                  <a
                    className="false"
                    style={
                      webinar.search_disciplines.length === 0
                        ? { display: "none", cursor: "pointer" }
                        : { cursor: "pointer" }
                    }
                    onClick={() => {
                      onSelectChangeDisciplineSearch([]);
                    }}
                  >
                    Deselect all
                  </a>
                </div>
              </div>
            )}

            <AddSpeaker
              onChange={onExpertChange}
              onAddElement={onExpertAdd}
              onRemoveElement={onExpertRemove}
              onDragEnd={onDragEnd}
              speakers={webinar.experts_attributes}
            />

            {hideMoreValue ? null : (
              <SelectField
                className="col s12"
                label={labels["cpd_status"]}
                onChange={onCpdTypeChange}
                errors={errors["cpd_status"]}
                autoComplete="new-password"
                field_name="cpd_status"
                value={webinar.cpd_status || ""}
                options={cpdStatus}
              />
            )}

            {!hideMoreValue &&
              (webinar.cpd_status === CPD_STATUSES.granted ||
                webinar.cpd_status === CPD_STATUSES.applied_for) && (
                <SelectField
                  className="col s12"
                  label={labels["ref_type"]}
                  onChange={onCertificateRefChange}
                  errors={errors["ref_type"]}
                  // autoComplete='new-password'
                  field_name="ref_type"
                  value={webinar.ref_type}
                  options={refType}
                />
              )}
            {!hideMoreValue &&
              webinar.cpd_status === CPD_STATUSES.granted &&
              webinar.ref_type !== REF_TYPES.FSEM &&
              !isCustomCertificate && (
                <InputField
                  className="col s12"
                  label={labels[getCertificateRefFieldName(webinar.ref_type)]}
                  field_name={getCertificateRefFieldName(webinar.ref_type)}
                  onChange={onFieldChange}
                  errors={errors[getCertificateRefFieldName(webinar.ref_type)]}
                  autoComplete="new-password"
                  value={webinar[getCertificateRefFieldName(webinar.ref_type)]}
                />
              )}

            {!hideMoreValue &&
              webinar.cpd_status === CPD_STATUSES.granted &&
              !isCustomCertificate && (
                <SelectField
                  className="col s12"
                  label={labels["cpd_points"]}
                  onChange={onCpdPointsChange}
                  errors={errors["cpd_points"]}
                  autoComplete="new-password"
                  field_name="cpd_points"
                  value={webinar.cpd_points}
                  options={cpdPoints}
                />
              )}
            {!hideMoreValue &&
              !isCustomCertificate &&
              cpdPointsFields.map((field) => (
                <InputField
                  className="col s12"
                  label={labels[field]}
                  field_name={field}
                  onChange={onCpdPointsChange}
                  errors={errors[field]}
                  autoComplete="new-password"
                  value={webinar[field] || ""}
                />
              ))}

            {!hideMoreValue &&
              webinar.ref_type === REF_TYPES.ICGP &&
              !isCustomCertificate && (
                <InputField
                  className="col s12"
                  label={labels["gms_study_days"]}
                  field_name={"gms_study_days"}
                  onChange={onFieldChange}
                  errors={errors["gms_study_days"]}
                  autoComplete="new-password"
                  value={webinar["gms_study_days"]}
                />
              )}
            <SelectField
              className="col s12"
              label={labels["status"]}
              onChange={onFieldChange}
              errors={errors["status"]}
              autoComplete="new-password"
              field_name="status"
              value={webinar.status}
              options={statuses}
            />
            <div>
              <div className="col s12">
                <Select
                  options={sponsorsOptions}
                  placeholder="Select sponsors"
                  value={webinar.sponsor_ids}
                  onChange={onSponsorChange}
                  multi={true}
                />

                <a
                  className={`${!webinar.sponsor_ids && "hide"}`}
                  href="javascript:void(0)"
                  onClick={() => {
                    onFieldChange({
                      target: { name: "sponsor_ids", value: [] },
                    });
                  }}
                >
                  Clear
                </a>
              </div>
            </div>

            <button
              onClick={onSubmit}
              className="button_classic"
              type="button"
              name="button"
            >
              Save
            </button>
          </form>
        </div>
      </div>
      {hideMoreValue ? null : (
        <NewQuiz
          onChange={onQuizChange}
          onAddElement={onQuizAdd}
          onRemoveElement={onQuizRemove}
          quizzes={webinar.spd_quizzes_attributes.filter((e) => !e._destroy)}
          // quizzes={webinar.spd_quizzes_attributes}
        />
      )}
    </div>
  );
};

EditWebinarForm.defaultProps = {};

EditWebinarForm.propTypes = {
  webinar: PropTypes.obj,
  errors: PropTypes.obj,
  onFieldChange: PropTypes.func,
  onQuizAdd: PropTypes.func,
  onQuizChange: PropTypes.func,
  onDateChange: PropTypes.func,
  onSubmit: PropTypes.func,
  onQuizRemove: PropTypes.func,
  onSponsorChange: PropTypes.func,
  cpdPointsFields: PropTypes.arr,
  counties: PropTypes.array,
  onWebinarTypeChange: PropTypes.func,
  onSessionAdd: func,
  onSessionChange: func,
  onSessionRemove: func,
};

const mapStateToProps = (state) => ({
  counties: state.suggestions.county.values,
});

export default connect(mapStateToProps)(EditWebinarForm);



// WEBPACK FOOTER //
// ./src/components/StudyGroupSuperhost/StudyGroupSuperhostEditWebinar/StudyGroupSuperhostEditWebinarForm.jsx